function generateDomainRegex(domain: string): RegExp {
    return new RegExp(`^https?://([^\\\\/]+\\.)*${ domain.replace(".", "\\.") }(:\\d+)?(/|$)`, "i");
}

export default {
    generateDomainRegex
};
